/**
 * LE BOUTON LECTURE/PAUSE, RÉGLÉ VIDÉO PAR VIDÉO (19/09/2026, fondatrice : « chaque composant vidéo doit
 * avoir cette config à lui seul, une vidéo on peut activer le pause button une autre non »).
 *
 * POURQUOI PAS UN RÉGLAGE DE THÈME. Le disque n'est pas une décision de marque, c'est une décision de
 * PLAN : une bande héros qui tourne en fond décoratif n'a pas le même besoin qu'un clip produit de trente
 * secondes qu'on veut pouvoir arrêter. Un interrupteur global aurait forcé le même choix aux deux, et
 * c'est exactement ce que la demande écarte. Le champ vit donc à côté de la vidéo qu'il commande — au
 * niveau du BLOC quand la section porte plusieurs vidéos (colonnes, collage, diaporama, cartes), au
 * niveau de la section quand elle n'en porte qu'une (héros, image+texte, section Vidéo).
 *
 * LE DÉFAUT EST ÉTEINT, PARTOUT (20/09/2026, fondatrice : « by default it shouldn't show »). La première
 * livraison gardait « ce que la boutique faisait déjà » — `true` pour la section Vidéo, le carrousel
 * d'images et les avis Facebook — pour ne rien bouger en ligne. La fondatrice a tranché l'inverse : une
 * vidéo posée dans une page est d'abord une image qui bouge, et un disque stampé sur la photo d'un produit
 * est une décision, pas un défaut. `defaultOn: false` est donc la seule valeur attendue ici ; le paramètre
 * reste explicite pour que chaque appelant AIT À l'écrire, et pour le jour où une section aurait une
 * raison à elle d'ouvrir autrement.
 *
 * LA RÈGLE QUI PROTÈGE LE VISITEUR — {@link showsPlayButton}. Masquer le disque sur un clip qui démarre
 * tout seul, c'est retirer une commande de confort. Le masquer sur un clip que le VISITEUR doit lancer
 * (son activé : aucun navigateur ne démarre un son de lui-même ; ou mode « clic pour lire »), c'est
 * livrer une image fixe sans aucune entrée au clavier. Dans ce cas le bouton reste, quoi que dise le
 * réglage, et le libellé du champ le dit.
 */
/** L'id unique du champ — partagé par toutes les sections, donc UNE seule clé `field.showPlayButton`. */
export const PLAY_BUTTON_FIELD = 'showPlayButton';
/** Le texte d'aide par défaut. Une section peut le remplacer quand son cadre mérite une phrase à elle. */
export const PLAY_BUTTON_INFO = 'Puts the round play/pause disc on the video, so a visitor can stop it. It fades away while the clip runs and comes back on hover, on focus and on tap. A video the visitor has to start — sound on, or click-to-play — always keeps its button.';
/**
 * Le champ, prêt à être épandu dans un `fields[]` de section ou de bloc.
 *
 * `defaultOn` reste obligatoire et explicite : la valeur attendue est `false` partout (voir l'en-tête),
 * et l'écrire à chaque appel rend visible en revue le jour où une section s'en écarterait.
 */
export function playButtonField(opts) {
    return {
        id: PLAY_BUTTON_FIELD,
        type: 'checkbox',
        label: 'Show the play/pause button',
        default: opts.defaultOn,
        info: opts.info ?? PLAY_BUTTON_INFO,
        ...(opts.group ? { group: opts.group } : null),
        ...(opts.visibleWhen ? { visibleWhen: opts.visibleWhen } : null),
    };
}
/**
 * Ce que la vendeuse a demandé pour CETTE vidéo — `fallback` étant le comportement historique de la
 * section. Lu comme un booléen strict : un document écrit avant ce commit n'a pas la clé, et c'est le
 * `fallback` qui répond (jamais `=== true`, qui aurait éteint le disque des six sections qui l'ont).
 */
export function wantsPlayButton(value, fallback) {
    return typeof value === 'boolean' ? value : fallback;
}
/**
 * La réponse finale : le réglage, SAUF quand la vidéo ne peut pas démarrer d'elle-même.
 *
 * `startsItself` = le clip est en lecture automatique ET muet. Dès que le son est demandé, ou que la
 * section est en « clic pour lire », le navigateur attend un geste — et un cadre figé sans bouton n'est
 * atteignable ni à la souris ailleurs que par un clic sur l'image (que le clavier n'a pas), ni au
 * lecteur d'écran. Le disque reste.
 */
export function showsPlayButton(wanted, startsItself) {
    return wanted || !startsItself;
}
//# sourceMappingURL=videoPlayButton.js.map